import { render } from "./HHAbnormalCallList.vue?vue&type=template&id=776bd9fc&scoped=true"
import script from "./HHAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./HHAbnormalCallList.vue?vue&type=script&lang=js"

import "./HHAbnormalCallList.vue?vue&type=style&index=0&id=776bd9fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-776bd9fc"

export default script